import './AboutPage.css';
import { useEffect, useState } from 'react';
import { fetchAppContent } from './services/api';

function AboutPage() {
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchAppContent()
      .then(data => {
        setHtml(data.about || '');
        setLoading(false);
      })
      .catch(err => {
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return (
    <div className="about-page-white">

      <div className="about-container">
        <section className="about-section-white">
          <h2>About Us</h2>
          {loading && (
            <div className="loader-wrap">
              <div className="spinner"></div>
            </div>
          )}
          {error && <p className="error-text">{error}</p>}
          {!loading && !error && (
            <div dangerouslySetInnerHTML={{ __html: html }} />
          )}
        </section>
      </div>

    </div>
  );
}

export default AboutPage;
